import { TranslationMap } from '@trimble-gcs/i18n-types';

export function downloadSelectTranslations() {
  return {
    title: {
      text: $localize`:@@downloadSelect.title:Download Files`,
      desc: 'Title for the download file select panel.',
    },
    close: {
      tooltip: {
        text: $localize`:@@downloadSelect.close.tooltip:Close`,
        desc: 'Tooltip for the top right "X" button that closes the download file select panel.',
      },
    },
  } satisfies TranslationMap;
}
